import request from "@/api/axios";
import { apiList as api } from "./apiList";

// 获取平台应用列表
export function getPlatformAppList(platid) {
  return request({
    url: api.menu.getPlatformAppList + platid,
    method: "get",
  })
}

// 获取指定应用子菜单

export function getAppSubmenu(appid) {
  return request({
    url: api.menu.getAppSubmenu + appid,
    method: "get",
  })
}
export function searchHelpCenter(data) {
  return request({
    url: api.menu.searchHelpCenter,
    method: 'post',
    data,
  })
}
